import { FC } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import StepScreenLayout from "components/layouts/StepScreenLayout/StepScreenLayout";
import {
  CodeVerificationInitialValues,
  CodeVerificationValidationSchema
} from "app/data/helpers/fietsgestolenHelpers";
import { AllsetraTriangles, CircleTwo, PlusTwo } from "assets/icons";
import {
  LogoWrapper,
  TrianglesWrapper,
  VectorSVGs
} from "../FietsgestolenForms.styled";
import { useAppDispatch, useAppSelector } from "hooks";
import { IAddVerificationCode } from "app/data/types";
import {
  setVerificationCodeFietsgestolen,
  verifyCodeThunk
} from "app/features";
import { selectUserDataState } from "app/data/selectors";
import InnerForm from "./children/InnerForm";

interface Props {
  gotoNextStep: () => void;
}

const ActivateCodeVerificationForm: FC<Props> = ({ gotoNextStep }) => {
  const dispatch = useAppDispatch();

  const { userEmail, verificationCodeLoadingFietsgestolen } =
    useAppSelector(selectUserDataState);

  const onSubmitHandler = async (
    value: IAddVerificationCode,
    formikHelpers: FormikHelpers<IAddVerificationCode>
  ) => {
    formikHelpers.setSubmitting(true);

    const formattedData = {
      email: userEmail,
      ...value
    };

    const verifyCodeAction = await dispatch(verifyCodeThunk(formattedData));

    if (verifyCodeAction.type === "fietsgestolen/verifyCodeThunk/fulfilled") {
      formikHelpers.resetForm();
      dispatch(setVerificationCodeFietsgestolen(value.verificationCode));
      gotoNextStep();
    }

    formikHelpers.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={CodeVerificationInitialValues}
      onSubmit={onSubmitHandler}
      validationSchema={CodeVerificationValidationSchema}
      enableReinitialize
      validateOnMount
    >
      {({ handleSubmit, isValid }) => (
        <Form>
          <VectorSVGs>
            <PlusTwo style={{ position: "absolute", right: 0, top: "25vh" }} />
          </VectorSVGs>

          <LogoWrapper>
            <TrianglesWrapper>
              <AllsetraTriangles />
            </TrianglesWrapper>
          </LogoWrapper>

          <StepScreenLayout
            title="Code Verificatie"
            subtitle="Voer je e-mailadres in om je diefstal te melden en ontvang een verificatiemail. Check je spambox als je geen e-mail hebt ontvangen."
            disabled={!isValid}
            onButtonSubmit={handleSubmit}
            buttonText="Verstuur verificatiemail"
            isFietsgestolen={true}
            loading={verificationCodeLoadingFietsgestolen}
          >
            <InnerForm />
          </StepScreenLayout>
        </Form>
      )}
    </Formik>
  );
};

export default ActivateCodeVerificationForm;
